module.exports = __webpack_public_path__ + "img/thumbDown2_ws.f3ca539d.png";